import { render, staticRenderFns } from "./PanelFirms.vue?vue&type=template&id=14744dd2&"
import script from "./PanelFirms.vue?vue&type=script&lang=ts&"
export * from "./PanelFirms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports